<div class="breadcrumb" fxShow.lt-md="false" fxShow="true">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let i=index">
    <a class="breadcrumb-link" [routerLink]="[breadcrumb.url]"
       *ngIf="i < breadcrumbs.length-1">{{ breadcrumb.label }}</a>
    <span class="breadcrumb-last-element" *ngIf="i == breadcrumbs.length-1">{{ breadcrumb.label }}</span>
    <span *ngIf="i < breadcrumbs.length-1"> > </span>
  </ng-container>
</div>
